import { useEffect, useRef } from 'react';
import api from '../api';

// Help Desk pages ask the server every few seconds whether anything they show
// has changed (a pulse endpoint returning { sig, every }), and call onChange
// only when it has. The server says how often: per queue, fast where techs
// race for tickets (IT), slower elsewhere -- set on the queue admin page.
// Not while the browser tab is hidden; once straight away on coming back.
export default function useHelpdeskPulse(url, onChange) {
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  useEffect(() => {
    let sig = null, every = 30, timer = 0, busy = false, stopped = false;
    const check = async () => {
      if (busy || stopped) return;
      clearTimeout(timer);
      busy = true;
      if (!document.hidden) {
        try {
          const r = await api.get(url);
          if (stopped) return;
          every = r.data.every || every;
          if (sig !== null && r.data.sig !== sig) onChangeRef.current();
          sig = r.data.sig;
        } catch { /* the next check tries again */ }
      }
      busy = false;
      if (!stopped) timer = setTimeout(check, every * 1000);
    };
    check();
    const onVisible = () => { if (!document.hidden) check(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { stopped = true; clearTimeout(timer); document.removeEventListener('visibilitychange', onVisible); };
  }, [url]);
}
